import { Modal } from 'react-bootstrap'
import React, { useEffect, useRef, useState } from 'react'
import { useTheme } from '../../context/ThemeContext'
import { useParams } from 'react-router-dom'
import { useBoardPersons, useGetMember } from '../../hooks'
import useSendAlert from '../../hooks/useSendAlert'
import Skeleton from 'react-loading-skeleton'
import Comments from '../Comments/Comments'

type Props = {
    addCommentModal: boolean;
    setAddCommentModal: (value: boolean) => void;
    cardDetails: any; // Replace 'any' with the actual type if available
    boardId: string;
};

const AddCardComment = ({
    addCommentModal,
    setAddCommentModal,
    cardDetails, boardId
}: Props): React.JSX.Element => {
    const { theme } = useTheme()
    const params: any = useParams()
    const [commentsLoading, setCommentsLoading] = useState<boolean>(false)
    const [editorComment, setEditorComment] = useState<string | null>(null)
    const { boardPerson } = useGetMember(boardId)

    const {
        isUserAssignLoading,
        optionsForSendAlert,
        boardPersonsForSendAlert,
        getBoardPersonHandler,
    } = useBoardPersons(cardDetails)

    const childCommentRef: any = useRef()
    const {
        sendAlertToComment,
        setSendAlertToComment,
        sendAlertMsgComment,
        sendAlertToBoardPerson,
        sendAlertToMentionPerson
    } = useSendAlert(
        boardPersonsForSendAlert,
        cardDetails,
        boardId,
        editorComment,
        cardDetails?.description
    )
    useEffect(() => {
        getBoardPersonHandler(params?.boardId || cardDetails?.boardId)
        //eslint-disable-next-line

    }, [cardDetails?.id])

    return (
        <Modal
            contentClassName={theme === 'dark' ? 'theme__div' : ''}
            show={addCommentModal}
            onHide={() => setAddCommentModal(false)}
            size='lg'
            aria-labelledby='contained-modal-title-vcenter'
            backdrop='static'>
            <Modal.Header>
                <Modal.Title
                    className={`text-center w-100 fw-bold ${theme === 'dark' ? 'white__text' : ''}`}
                >
                    Add Comment for {cardDetails?.key}
                </Modal.Title>
                <i className={`bi bi-x-lg modal-icon-custom ${theme === 'dark' && 'close'}`} onClick={() => {
                    setAddCommentModal(false)
                }}></i>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '900px', overflowY: 'scroll' }} className={theme === 'dark' ? 'dark-mode-placeholder' : ''}>

                {isUserAssignLoading ? <React.Fragment>
                    <Skeleton count={1} height={35} />
                    <Skeleton count={1} height={155} />
                </React.Fragment>
                    : (
                        <Comments
                            ref={childCommentRef}
                            optionsForSendAlert={optionsForSendAlert}
                            setSendAlertToComment={setSendAlertToComment}
                            sendAlertToComment={sendAlertToComment}
                            sendAlertToBoardPerson={sendAlertToBoardPerson}
                            cardDetails={cardDetails}
                            boardPersonsForSendAlert={boardPersonsForSendAlert}
                            setEditorComment={setEditorComment}
                            editorComment={editorComment}
                            sendAlertMsgComment={sendAlertMsgComment}
                            role={boardPerson?.role}
                            isUserAssignLoading={isUserAssignLoading}
                            sendAlertToMentionPerson={sendAlertToMentionPerson}
                            commentsLoading={commentsLoading}
                            setCommentsLoading={setCommentsLoading}
                            skipReadComments={true}
                            closeAddModal={() => setAddCommentModal(false)}
                        />
                    )}
            </Modal.Body>

        </Modal>
    )
}

export default AddCardComment
